<template>
  <div class="box-information-content">
    <a-card :bordered="false" size="small">
      <a-row>
        <a-col :span="7">
          <!--/* Contact info */-->
          <div class="contact-info">
            <div class="item">
              <label class="title">
                <a class="link-btn" @click="handleEditBookType"><strong>Contact info:</strong></a>
              </label>
              <a class="link-btn" @click="handleContact" style="margin-left: 10px;">Contact</a>
            </div>
            <div class="item">
              <span>fullName</span>
            </div>
            <div class="item">
              <span>phoneNumber </span><span>Ext.123</span>
            </div>
            <div class="item">
              <span>test@163.com</span>
            </div>
          </div>
        </a-col>
        <a-col :span="7">
          <!--/* Agency Info */-->
          <div class="agency-info">
            <div class="item"><label class="title"><strong>Agency:</strong></label></div>
            <div class="item">
              <span>测试测试</span>
            </div>
            <div class="item">
              201 666 6666
            </div>
            <div class="item">
              test@163.com
            </div>
            <div class="item">
              test <span>/ test@163.com</span>
            </div>
          </div>
        </a-col>
        <a-col :span="10">
          <!--/* Tour Info */-->
          <div class="tour-info">
            <div class="item">
              <span style="color: #000;">云南风情游</span>
              <a class="link-btn"><span style="margin-left: 5px;" @click="openTourList">2345</span></a>
              <a-popover placement="right">
                <div slot="content" class="tour-code-popover">
                  <p>Total room </p>
                  <p>Room sold </p>
                  <p>Guest adult </p>
                  <p>Guest child </p>
                </div>
                <span style="cursor: default;">(R)</span>
              </a-popover>
            </div>
            <div class="item">
              <label><strong>Tour starts/ends: </strong></label>
              <span>07/08/2020 - 07/08/2021</span>
            </div>
            <div class="item">
              <label><strong>Tour Language: </strong></label>
              <span>English</span>
            </div>
            <div class="item">
              <label><strong>Rep.: </strong></label>
              <a class="link-btn" @click="handleEditRep">Sales</a>
            </div>
          </div>
        </a-col>
      </a-row>
    </a-card>
    <div>
      <contact-information
        :bookNo="contactBookNo" 
        @cancel="() => { this.contactBookNo = null }"
        @confirm="() => { this.contactBookNo = null }"
      />
    </div>
    <div>
      <contact-book
        :bookTypeNum="contactBookType" 
        @cancel="() => { this.contactBookType = null }"
        @confirm="() => { this.contactBookType = null }"
      />
    </div>
    <div>
      <contact-sales
        :bookReqSales="contactBookReq" 
        @cancel="() => { this.contactBookReq = null }"
        @confirm="() => { this.contactBookReq = null }"
      />
    </div>
  </div>
</template>

<script>
import ContactInformation from './ContactInformation'
import ContactBook from './ContactBookingType'
import ContactSales from './ContactRep'

export default {
  name: 'ContactInfo',
  components: {
    ContactInformation,
    ContactBook,
    ContactSales
  },
  props: {
  },
  data () {
    return {
      contactBookNo: null,
      contactBookType: null,
      contactBookReq: null
    }
  },
  mounted () {
  },
  methods: {
    handleContact () {
      this.contactBookNo = 'true'
    },
    handleEditBookType () {
      this.contactBookType = 'true'
    },
    openTourList () {
    },
    handleEditRep () {
      this.contactBookReq = 'true'
    }
  }
}
</script>
<style lang="less" scoped>
.box-information-content .item {
  color: #333;
}
.box-information-content a {
  user-select: none;
}
</style>